import { Color } from 'root-constants'
import styled, { css } from 'styled-components'
import { Button } from 'components/Button'

type TPropsWrapper = {
  isShown: boolean
}

const commonTitleStyles = css`
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: ${Color.DARK};
`

const commonButtonStyles = css`
  margin-top: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  border-radius: 16px;
`

export const StyledPaymentWaitingModal = {
  Wrapper: styled.div<TPropsWrapper>`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${({ isShown }) => (isShown ? 103 : -1)};
    width: max(100%, var(--min-screen-width));
    height: calc(var(--full-height) - calc(var(--full-height) - 100%));
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.25);
    opacity: ${({ isShown }) => (isShown ? 1 : 0)};
    transition-duration: 100ms;
    transition-property: opacity;
    transition-timing-function: ease-out;
  `,
  Content: styled.div`
    max-width: 290px;
    margin: auto;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    border-radius: 20px;
    background-color: ${Color.WHITE};
  `,
  LottieContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  `,
  Animation: styled.div`
    width: 132px;
    height: 132px;
  `,
  Title: styled.div`
    ${commonTitleStyles};
    padding-bottom: 8px;
    font-size: 24px;
    line-height: 33px;
  `,
  Subtitle: styled.div`
    ${commonTitleStyles};
    padding: 10px 15px;
    font-size: 15px;
    line-height: 18px;
  `,
  LoadingInfo: styled.p`
    padding: 0 20px 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #4e5160;
  `,
  Info: styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #4e5160;
  `,
  ErrorButton: styled(Button)`
    ${commonButtonStyles};
    background: ${Color.ERROR};
  `,
  SuccessButton: styled(Button)`
    ${commonButtonStyles};
    background: #60d512;
  `,
}
